import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoaderService, MobileSSOService } from '~services';

@Component({
  selector: 'app-mobilesso-view',
  template: ``,
  standalone: false,
})
export class MobileSSOViewComponent implements OnInit, OnDestroy {
  constructor(
    private activatedRoute: ActivatedRoute,
    private mobileSSOService: MobileSSOService,
    private loaderService: LoaderService,
  ) {}

  async ngOnDestroy(): Promise<void> {
    this.loaderService.hide();
  }

  async ngOnInit(): Promise<void> {
    this.loaderService.show();
    this.mobileSSOService.handleSSOComplete();
  }

  private get returnTo() {
    return this.activatedRoute.snapshot.queryParams.returnTo;
  }
}
